import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { DataService } from '../services/data.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-sample-detail',
  templateUrl: './sample-detail.component.html',
  styleUrls: ['./sample-detail.component.css']
})
export class SampleDetailComponent {
  selectedId: number = 0;
  sample: any = {isOpen: false};
  reportFile: any;
  constructor(private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private dataService: DataService,
    private messageService: MessageService) {}

  ngOnInit() {
    //this.sample = {id:123, runName: "testrun123", sampleName: "testsample123", totalSeqs: 8128398512, seqQual: "30.3", isApproved:true, isRetested:false};
    const id = this.route.snapshot.paramMap.get('sampleId');
    this.selectedId = +id!;
    this.loadData(this.selectedId);
    this.dataService.getSampleReport(this.selectedId).then(data => {
      this.reportFile = this.sanitizer.bypassSecurityTrustHtml(data);
    });
  }
  
  approve(record: any){
    this.dataService.approveSample(record.sampleId)
      .then(data => {
        this.messageService.add({severity:'success', summary:'Approved sample ' + record.name + ' successfully.'});
        this.loadData(this.selectedId);
      })
      .catch(error => {
        this.messageService.add({severity:'error', summary:'Sample ' + record.name + ' could not be approved.'});
      });
  }

  retest(record: any){
    this.dataService.retestSample(record.sampleId)
      .then(data => {
        this.messageService.add({severity:'success', summary:'Retested sample ' + record.name + ' successfully.'});
        this.loadData(this.selectedId);
      })
      .catch(error => {
        this.messageService.add({severity:'error', summary:'Sample ' + record.name + ' could not be retested.'});
      });
  }

  loadData(id: number){
    this.dataService.getSampleDetail(id).then(data => {
      this.sample = data;
    });
  }
}
